import React, { useEffect, useState } from "react";

export function CountDown() {
  const targetDate = "2024-06-17T20:59:59Z"; // target date in the format "YYYY-MM-DDTHH:mm:ssZ"
  const calculateTimeLeft = () => {
    const difference = +new Date(targetDate) - +new Date();
    let timeLeft = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return (
    <div className="grid grid-flow-col gap-5 text-center auto-cols-max">
      <div className="flex flex-col items-center">
        <span className="countdown font-mono text-xl">
          <span
            style={{ "--value": timeLeft.days } as React.CSSProperties}
          ></span>
        </span>
        <span className="text-xs">GÜN</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="countdown font-mono text-xl">
          <span
            style={{ "--value": timeLeft.hours } as React.CSSProperties}
          ></span>
        </span>
        <span className="text-xs">SAAT</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="countdown font-mono text-xl">
          <span
            style={{ "--value": timeLeft.minutes } as React.CSSProperties}
          ></span>
        </span>
        <span className="text-xs">DAKİKA</span>
      </div>
      <div className="flex flex-col items-center">
        <span className="countdown font-mono text-xl">
          <span
            style={{ "--value": timeLeft.seconds } as React.CSSProperties}
          ></span>
        </span>
        <span className="text-xs">SANİYE</span>
      </div>
    </div>
  );
}

export default CountDown;
